import React from 'react';

import PropTypes from 'prop-types';

import ValueItem from 'components/Widgets/Profile/ValueItem';

export default function LastPromotion({ member }) {
  return (

    <ValueItem
      icon="last-promotion-icon"
      label="Last Promotion"
    >
      {member.career_histories.find((item) => item.code === 'CUSTOM_CH_Q2')?.answer}
    </ValueItem>
  );
}

LastPromotion.propTypes = {
  member: PropTypes.object.isRequired,
};
